import UserProfile from '@srcDS/components/atoms/icons/UserProfile';
import AccountDropdown from '../account/accountDropdown';
import { FORM_TYPE } from '../account/accountDropdown/AccountDropdown';
import styles from './HeaderActions.module.scss';
import app from '@frontastic/catwalk/js/app/app';
import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useMedia } from 'react-use';
import { useScrollLock } from '@srcDS/utils/useLockScroll';
import { useCartContext } from '@srcDS/provider/cart/CartContext';
import Cart from '../../organisms/cartPopups/Cart';
import { CartButton } from '../../organisms/header/navigation/CartButton/CartButton';
import Portal from '../../atoms/portal';
import { useLayoutContext } from '@srcDS/provider/layout/LayoutContext';
import { WishlistButton } from '@srcDS/components/organisms/header/navigation/WishlistButton/WishlistButton';
import { useMenuContext } from '@srcDS/provider/menu/MenuContext';

const HeaderActions = ({
  handleRegister,
  handleLogin,
  loggedIn,
  customerGroupId,
  showLoginForm,
  setToggleLoginForm,
  isStickyHeader,
  isInvertedClass,
  shippingCoastMessage,
  nostoBlocks,
  accountDropdownPromo,
  accountDropdownContentBlock,
  isMobile,
  onClickWishlist,
  showMarquee,
}) => {
  const isTablet = useMedia('(min-width: 767px)', true);
  const isDesktopMenu = useMedia('(min-width: 1025px)', true);
  const { setShowCart } = useCartContext();
  const { showFormByName, setShowFormByName, showSearchDropdown } = useLayoutContext();
  const { setActiveLevel1 } = useMenuContext();

  const handleMouseOver = () => {
    setActiveLevel1(null);
  };

  useScrollLock(Boolean((showFormByName && !isDesktopMenu) || showSearchDropdown));

  useEffect(() => {
    showLoginForm && setShowFormByName(FORM_TYPE.LOGIN);
  }, [showLoginForm]);

  const handleAccountClick = () => {
    return loggedIn
      ? isTablet
        ? app.getRouter().push('Frontastic.Frontend.Master.Account.profile')
        : app.getRouter().history.replace('/account')
      : setShowFormByName(FORM_TYPE.LOGIN);
  };

  return (
    <div
      className={styles.headerActions}
      onMouseOver={handleMouseOver}
    >
      <div className={clsx(styles.headerActionsItem, styles.user)}>
        <div id="openAccountPopup">
          <span
            id="loginOpenButtonMob"
            onClick={handleAccountClick}
            className={clsx(styles.userProfile, isInvertedClass)}
            data-user-icon={isMobile ? 'user_icon_mob' : 'user_icon_desk'}
          >
            <UserProfile />
          </span>
        </div>
      </div>

      {showFormByName && (
        <AccountDropdown
          formName={showFormByName}
          handleSetFormName={setShowFormByName}
          handleRegister={handleRegister}
          handleLogin={handleLogin}
          isSticky={isStickyHeader}
          showMarquee={showMarquee}
          contentBlock={accountDropdownContentBlock}
          promo={accountDropdownPromo}
          onCloseAction={() => {
            setTimeout(() => setShowFormByName(null), 100);
            setToggleLoginForm(false);
          }}
          showCart={() => setShowCart(true)}
        />
      )}
      <div className={styles.headerActionsItem}>
        <WishlistButton onClick={onClickWishlist} isInvertedClass={isInvertedClass} />
      </div>
      <div className={clsx(styles.headerActionsItem, styles.cart)}>
        <CartButton isMobile={isMobile} isInvertedClass={isInvertedClass} />
        <Portal>
          <Cart
            loggedIn={loggedIn}
            customerGroupId={customerGroupId}
            promo={accountDropdownPromo}
            shippingCoastMessage={shippingCoastMessage}
            nostoBlocks={nostoBlocks}
          />
        </Portal>
      </div>
    </div>
  );
};

export default HeaderActions;
